// Duplicates server-request-tok.ts
const TOK_WINDOW = 30; // seconds per bucket

let cachedTok: { value: string; bucket: number } | null = null;

export async function generateTok(): Promise<string> {
  const secret = "caliitoktokensecret";

  const bucket = Math.floor(Date.now() / 1000 / TOK_WINDOW);

  // Reuse cached token if still in the same bucket
  if (cachedTok && cachedTok.bucket === bucket) return cachedTok.value;

  const key = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(secret),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );

  const sig = await crypto.subtle.sign(
    "HMAC",
    key,
    new TextEncoder().encode(bucket.toString())
  );

  const sigHex = Array.from(new Uint8Array(sig))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  const tok = btoa(`${bucket}.${sigHex}`);
  cachedTok = { value: tok, bucket };
  return tok;
}
